import { goerli, mainnet } from 'wagmi/chains'

import { Hash } from 'types/entities'

export const MAD_ASSEMBLY: Record<number, Hash> = {
  [mainnet.id]: '0x83a2Fa9FE32Bdb02A69029bfAC9B8A1c4C0E8733',
  [goerli.id]: '0xc4b279542739c3184ea443aa2849a021ce653a00',
}

export const ZERO_ADDRESS: Hash = '0x0000000000000000000000000000000000000000'
export const ETH_ADDRESS: Hash = '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE'
export const MULTICALL_ADDRESS: Hash = '0xcA11bde05977b3631167028862bE2a173976CA11'
